{/* <li class="collections-grid__item  collections-grid__item--{{ brand.id }} 
            color-{{ section.settings.color_scheme }} background
            {% if section.settings.image_ratio == 'portrait' or section.settings.image_ratio == 'portrait' %} collections-grid__card--portrait {% endif %}
            collections-grid__item--{{- section.settings.image_ratio }}">
          <span class="collections-grid__overlay" style="--opacity: {{ section.settings.overlay_opacity }}; 
              --opacity-hover: {{ section.settings.overlay_opacity | plus: 0.1 }}">
</span>

          <div class="collections-grid__image collections-grid__image--{{- section.settings.image_fit -}}">
            {%- capture sizes -%}
                  (min-width: 1360px) calc(100vw / {{ section.settings.brands_to_show_to_show }} - 128px)
                  (min-width: 990px) {% if section.settings.brands_to_show_to_show == 4 %} calc(100vw / 3 - 40px) {% else %} calc(100vw / {{ section.settings.brands_to_show_to_show }} - 40px) {%  endif %},
                  (min-width: 750px) {% if section.settings.brands_to_show_to_show >= 3 %} calc(100vw / 2 - 40px) {% else %} calc(100vw / {{ section.settings.brands_to_show }} - 40px) {%  endif %},
                  calc(100vw - 40px)
                {%- endcapture -%}
            {% assign promo_imgs = brand.promotional_images.value %}
            {% if promo_imgs != blank %}
              {% assign first_image = promo_imgs | first %}
              {{
                first_image | image_url: width: first_image.value.width | image_tag: sizes: sizes, widths: '360, 550, 750, 900, 1100, 1420, 1700, 1920'
              }}
            {% endif %}
          </div>
          <div class="collections-grid__information">
            <h2 class="collections-grid__title text-3xl md:text-4xl lg:text-5xl">
              <span>{{- brand.brand_name -}}</span>
            </h2>
            {%- if brand.description != blank and section.settings.show_desc -%}
              <p class="collections-grid__desc">{{- brand.description | strip_html | truncatewords: 80, '...' -}}</p>
            {%- endif -%}
            {% if section.settings.show_button and section.settings.button_label %}
              <a href="{{ collection.url | default: '#' }}" class=" collections-grid__link button button--{{ section.settings.button_style }} focus-inset">
                {{ section.settings.button_label }}
              </a>
            {% endif %}
          </div>
          <a
            href="{{ collection.url | default: '#' }}"
            class=" collections-grid__link_overlay"
            aria-label="{{ brand.brand_name }}">
            <span class="visibility-hidden">{{ brand.brand_name }}</span>
          </a>
        </li> */}

(() => {
  let allBrands = []; // Store all brands for filtering
  
  const createBrand = (brand) => {
    const { id, onlineStoreUrl, name, description, imageUrl } = brand
    
    const parent = document.querySelector('.collections-list')
    // Create DOM element based on above comment
    const brandElement = document.createElement('li')
    brandElement.classList.add('collections-grid__item')
    brandElement.classList.add('collections-grid__item--' + id)
    brandElement.classList.add('background')
    brandElement.classList.add('brand-card') // Add class for easy selection
    brandElement.classList.add(...['bg-zinc-800', 'hover:bg-zinc-700', 'transition'])
    brandElement.setAttribute('data-brand-name', name.toLowerCase()) // Add data attribute for searching
    brandElement.setAttribute('data-brand-description', (description || '').toLowerCase()) // Add description for searching
    brandElement.innerHTML = `
      <div class="collections-grid__information">
        <h2 class="collections-grid__title text-3xl md:text-4xl lg:text-5xl text-white">
          <span>${name}</span>
        </h2>
        <p class="collections-grid__desc text-zinc-200">${description}</p>
      </div>
      <a
        href="${onlineStoreUrl}"
        class=" collections-grid__link_overlay"
        aria-label="${name}">
        <span class="visibility-hidden">${name}</span>
      </a>
    `
    parent.appendChild(brandElement)
  }
  
  const filterBrands = (searchTerm) => {
    const brandCards = document.querySelectorAll('.brand-card');
    const noResultsMessage = document.getElementById('no-results-message');
    let visibleCount = 0;
    
    searchTerm = searchTerm.toLowerCase().trim();
    
    brandCards.forEach(card => {
      const brandName = card.getAttribute('data-brand-name') || '';
      const brandDescription = card.getAttribute('data-brand-description') || '';
      
      if (searchTerm === '' || brandName.includes(searchTerm) || brandDescription.includes(searchTerm)) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });
    
    // Show/hide no results message
    if (visibleCount === 0 && searchTerm !== '') {
      noResultsMessage.style.display = 'block';
    } else {
      noResultsMessage.style.display = 'none';
    }
  }
  
  const initializeSearch = () => {
    const searchInput = document.getElementById('brand-search-input');
    if (!searchInput) return;
    
    // Add debounced search functionality
    let searchTimeout;
    searchInput.addEventListener('input', (e) => {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
        filterBrands(e.target.value);
      }, 300); // 300ms debounce
    });
    
    // Clear search on escape key
    searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        searchInput.value = '';
        filterBrands('');
      }
    });
  }

  const getBrands = () => {
    fetch('https://thecanvasglobal.myshopify.com/api/2024-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token':
          'a58d9cef05f7c85d1e7a6bade51c6969',
        'Accept': "application/json"
      },
      body: JSON.stringify({
        query: `
          query readMetaObjects {
            metaobjects(type:"brand", first:150){
              edges {
                node {
                  fields {
                    key
                    value
                  }
                  onlineStoreUrl
                }
              }
            }
          }
        `,
        variables: {}
      })
    })
      .then((res) => res.text())
      .then((res) => {
        if(!res) {
          // Unable to fetch brands - fail silently
        } else {
          const raw = JSON.parse(res);
          const data = raw?.data?.metaobjects?.edges

          const placeholderContainer = document.querySelector('.collections-list');

          // Remove all child elements (the placeholder <li> elements)
          while (placeholderContainer.firstChild) {
            placeholderContainer.removeChild(placeholderContainer.firstChild);
          }

          let brands = []
          for (let i = 0; i < data.length; ++i) {
            const { id, onlineStoreUrl, fields } = data[i].node
            let name
            let description
            let imageUrl
            for(let i = 0; i < fields.length; ++i) {
              const field = fields[i]
              if(field.key === "brand_name") {
                name = field.value
              } else if(field.key === "description") {
                description = field.value
              } else if(field.key === "image") {
                imageUrl = field.value
              }
            }
            const brand = {
              id,
              onlineStoreUrl,
              name,
              description,
              imageUrl
            }
            brands.push(brand)
          }
          brands.sort(function (a, b) {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          });
          allBrands = brands; // Store all brands for filtering
          brands.forEach((brand) => createBrand(brand));
          initializeSearch(); // Initialize search after brands are loaded
        }
      });
  };

  getBrands();

	document.addEventListener("shopify:section:load", () => {
    getBrands();
    // Re-initialize search after section reload
    setTimeout(initializeSearch, 500);
  });
})();
